export default __webpack_public_path__ + "static/media/19-Annual-Picnic-Wattson-Group-Executives.302c599f.JPG";